import React, { useEffect, useState } from "react";
import axios from "../axiosIn";
import {
  Accordion,
  Input,
  Card,
  Text,
  InputGroup,
  Message,
  toaster,
  DateInput,
  Button,
  IconButton,
  InputNumber,
  DatePicker,
  SelectPicker,
  Panel,
  Form,
  Carousel,
  Popover,
  Whisper,
} from "rsuite";
import SaveIcon from "@rsuite/icons/Save";
import { FaPencilAlt, FaSave } from "react-icons/fa";
import { Link } from "react-router-dom";
import { Label } from "reactstrap";
import moment from "moment/moment";
import { VscEdit, VscSave } from "react-icons/vsc";
import Table from "react-bootstrap/Table";

const { Column, HeaderCell, Cell } = Table;

export const Consulta = (noEspacio) => {
  const [idNegocio] = useState(JSON.parse(localStorage.getItem("auth")).id);
  const [idMedico, setIdMedico] = useState(
    JSON.parse(localStorage.getItem("auth")).idMedico
  );
  const idUser = JSON.parse(localStorage.getItem("auth")).idUser;
  const [nombre, setNombre] = useState(
    JSON.parse(localStorage.getItem("getCita")).nombre
  );
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768); // Initial check
  const [espacio] = useState(noEspacio);
  const [loaderDatos, setLoaderDatos] = useState(false);
  const [data, setData] = useState([]);
  const [activeKey, setActiveKey] = useState(1);
  const [fecNac, setFecNac] = useState("");
  const [correo, setCorreo] = useState("");
  const [ocupacion, setOcupacion] = useState("");
  const [genero, setGenero] = useState("");
  const [listGeneros] = useState([
    { label: "", value: "" },
    { label: "Femenino", value: "Femenino" },
    { label: "Masculino", value: "Masculino" },
    { label: "Otro", value: "Otro" },
  ]);
  const [fecha] = useState(JSON.parse(localStorage.getItem("getCita")).fecha);
  const [hora] = useState(JSON.parse(localStorage.getItem("getCita")).hora);
  const [defaultExpanded] = useState(true);
  const [disabledAccord2, setDisabledAccord2] = useState(true);
  const [disabledAccord3, setDisabledAccord3] = useState(true);
  const [disabledIni, setDisabledIni] = useState(false);
  const [showNombre, setShowNombre] = useState(false);
  const [showFecNac, setShowFecNac] = useState("");
  const [showCorreo, setShowCorreo] = useState("");
  const [showOcup, setShowOcup] = useState("");
  const [showGenero, setShowGenero] = useState(false);
  const [edad, setEdad] = useState(0);
  const [listaMedicos, setListaMedicos] = useState([]);
  const [listaAnteced, setListaAnteced] = useState([
    { nombre: "", detalles: [] },
  ]);

  const [domicilio, setDomicilio] = useState("");
  const [colonia, setColonia] = useState("");
  const [estado, setEstado] = useState("");
  const [municipio, setMunicipio] = useState("");
  const [listEdoCivil] = useState([
    { label: "", value: "" },
    { label: "Soltero(a)", value: "Soltero(a)" },
    { label: "Casado(a)", value: "Casado(a)" },
    { label: "Divorciado(a)", value: "Divorciado(a)" },
    { label: "Viudo(a)", value: "Viudo(a)" },
    { label: "Union Libre", value: "Union Libre" },
    { label: "Otro", value: "Otro" },
  ]);
  const [edoCivil, setEdoCivil] = useState("");
  const [diagnostico, setDiagnostico] = useState("");
  const [tratamiento, setTratamiento] = useState("");
  const [indicaciones, setIndicaciones] = useState("");

  const [idConsulta, setIdConsulta] = useState(0);
  const [diagnosticoCita, setDiagnosticoCita] = useState("");
  const [tratamientoCita, setTratamientoCita] = useState("");
  const [indicacionesCita, setIndicacionesCita] = useState("");
  const [observaCita, setObservaCita] = useState("");

  const [idTipoDoc, setIdTipoDoc] = useState("");
  const [loading, setLoading] = useState(false);
  const [disabledUPload, setDisabledUpload] = useState(true);
  const [observa, setObserva] = useState("");
  const [listServicios, setListServicios] = useState([
    { label: "", value: "" },
  ]);
  const [listCitas, setListCitas] = useState([{ label: "", vlaue: "" }]);
  const [listaTipoDocs, setListaTipoDocs] = useState([
    { label: "", value: "" },
  ]);
  const [disabledDiag, setDisabledDiag] = useState(true);
  const [disabledTrat, setDisabledTrat] = useState(true);
  const [disabledIndic, setDisabledIndic] = useState(true);
  const [idServicio, setIdServicio] = useState(0);
  const [telefono] = useState(
    JSON.parse(localStorage.getItem("getCita")).telefono
  );
  const [idPaciente, setIdPaciente] = useState(0);

  const [fileList, setFileList] = useState([]);
  const [imageList, setImageList] = useState([{ doc: "", tipoDoc: "" }]);

  const handleChange = (id, key, value) => {
    const nextData = Object.assign([], data);
    nextData.find((item) => item.id === id)[key] = value;
    setData(nextData);
  };

  const handleEdit = (id) => {
    const nextData = Object.assign([], data);
    const activeItem = nextData.find((item) => item.id === id);

    activeItem.status = activeItem.status ? null : "EDIT";

    setData(nextData);
  };

  const getPaciente = async () => {
    var url = `Consultas/getExistePaciente/${idNegocio}/${telefono}`;

    await axios
      .get(url)
      .then((response) => {
        if (response.data !== "") {
          setIdPaciente(response.data.idPaciente);
          setNombre(response.data.paciente);
          let _fecha = response.data.fechaNac;
          if (_fecha !== null) {
            const _fecNac = new Date(response.data.fechaNac);
            setFecNac(_fecNac);
          } else {
            setFecNac(null);
          }
          setDomicilio(response.data.calleNum);
          setColonia(response.data.colonia);
          setEstado(response.data.estado);
          setMunicipio(response.data.municipio);
          setCorreo(response.data.correo);
          setEdoCivil(response.data.edoCivil);
          if (response.data.genero === null) {
            setGenero("");
          } else {
            setGenero(response.data.genero);
          }
          setOcupacion(response.data.ocupacion);

          const dataPaciente = {
            idPaciente: response.data.idPaciente,
          };
          localStorage.setItem("dataPaciente", JSON.stringify(dataPaciente));
        } else {
          setIdPaciente(0);
          setFecNac("");
          setCorreo("");
          setOcupacion("");
          setEdad(0);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const getAntecedentes = async (idPac) => {
    var url = `Consultas/getAntecedentes/${idNegocio}/${idPac}`;
    setIdPaciente(idPac);
    await axios
      .get(url)
      .then((response) => {
        setListaAnteced(response.data);
      })
      .then((next) => {
        getServicios(idPac);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const getListaCitas = async (idPac) => {
    var url = `Consultas/getListaCitas/${idNegocio}/${idPac}`;

    await axios
      .get(url)
      .then((response) => {
        setListCitas(response.data);
        loadMedicos();
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const getDatosCita = async (fecha, idPac) => {
    var url = `Consultas/getDatosCita/${idNegocio}/${idPac}/${fecha}`;

    await axios
      .get(url)
      .then((response) => {
        setIdConsulta(response.data.idConsulta);
        setDiagnosticoCita(response.data.diagnostico);
        setTratamientoCita(response.data.tratamiento);
        setIndicacionesCita(response.data.indicaciones);

        getDocsCita(response.data.idConsulta);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const handleSetGenero = async (e) => {
    setShowGenero(false);
    setGenero(e);
    setTimeout(() => {
      saveDataField("genero", "");
    }, 500);
  };

  const getDocsCita = async (idConsulta) => {
    var url = `Consultas/getDocsCita/${idNegocio}/${idConsulta}`;

    await axios
      .get(url)
      .then((response) => {
        let doc = [];

        response.data.forEach((element) => {
          doc.push({ doc: element.NombreDoc, tipoDoc: element.tipoDoc });
        });
        setImageList(doc);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const loadMedicos = async () => {
    var url = `Consultas/getMedicos/${idNegocio}`;

    await axios
      .get(url)
      .then((response) => {
        setListaMedicos(response.data);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const getTipoDocs = async (idPac) => {
    var url = `Consultas/getTipoDoc/${idNegocio}`;

    await axios
      .get(url)
      .then((response) => {
        setListaTipoDocs(response.data);
      })
      .then((nxt) => {
        getListaCitas(idPac);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const getServicios = async (idPac) => {
    var url = `Consultas/getServicios/${idNegocio}`;

    await axios
      .get(url)
      .then((response) => {
        setListServicios(response.data);
      })
      .then((next) => {
        getTipoDocs(idPac);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const saveDatos = () => {};

  const saveDataField = async (name, goTo) => {
    if (name === "correo") {
      var valid = handleOnChange(correo);
      if (valid === 0) {
        toast("Formato de correo inválido.", "warning");
        return;
      }
    }

    let value = "";
    if (name === "nombre") {
      value = nombre;
    }
    if (name === "correo") {
      value = correo;
    }
    if (name === "ocupacion") {
      value = ocupacion;
    }
    if (name === "fecNac") {
      value = fecNac;
    }
    if (name === "genero") {
      value = genero;
    }

    const data = {
      id: idNegocio,
      idPaciente: idPaciente,
      telefono: telefono,
      campo: name,
      value: value,
    };

    

    var url = "Consultas/saveFieldDatos";
    await axios
      .post(url, data, {
        headers: {
          "Content-Type": "application/json",
        },
      })
      .then(async (res) => {
        if (res.data > 0) {
          setIdPaciente(res.data); // GRABAMOS EL ID DEL PACIENTE
          toast("Se actualizó la información de forma correcta.", "info");
          setShowNombre(false);
          setShowCorreo(false);
          setShowFecNac(false);
          setShowOcup(false);
          if (name === "fecNac") {
            getPaciente();
          }
          if (goTo === "Consulta") {
            // GRABAMOS EL ID DEL PACIENTE EN UN LOCAL STORAGE PARA UTILIZARCE EN LOS PRIMEROS ANTECEDENTES
            const dataPaciente = {
              idPaciente: res.data,
            };
            localStorage.setItem("dataPaciente", JSON.stringify(dataPaciente));
            getAntecedentes(res.data);
            handleAccordions(2);
          }
        } else {
          toast(
            "Error al actualizar, valide su conexión a internet",
            "warning"
          );
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const saveDataInit = async () => {
    if (correo) {
      var valid = handleOnChange(correo);
      if (valid === 0) {
        toast("Formato de correo inválido.", "warning");
        return;
      }
    } else {
      setCorreo("");
    }

    const data = {
      id: idNegocio,
      idPaciente: 0,
      nombre: nombre,
      fechaNac: fecNac,
      calleNum: domicilio,
      colonia: colonia,
      telefono: telefono,
      correo: correo,
      ocupacion: ocupacion,
      genero: genero,
      edoCivil: edoCivil,
      estado: estado,
      municipio: municipio,
    };

    var ID = 0;
    var url = "Consultas/saveDatosInit";
    await axios
      .post(url, data, {
        headers: {
          "Content-Type": "application/json",
        },
      })
      .then(async (res) => {
        if (res.data > 0) {
          ID = res.data;
          await setIdPaciente(res.data);
          toast("Se han guardado todos los datos.", "info");
        }
      })
      .then((next) => {
        getAntecedentes(ID);
        handleAccordions(2);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const handleAccordions = (opc) => {
    switch (opc) {
      case 1:
        setActiveKey(1);
        setDisabledAccord2(true);
        setDisabledAccord3(true);
        setDisabledIni(false);
        break;
      case 2:
        setActiveKey(2);
        setDisabledAccord2(false);
        setDisabledAccord3(false);
        setDisabledIni(true);
        break;
      default:
        break;
    }
  };

  const toast = (msg, type = "info") => {
    toaster.push(
      <Message showIcon type={type} closable>
        <strong>{type}!</strong>
        &nbsp; {msg}
      </Message>,
      { duration: 5000, placement: "topCenter" }
    );
  };

  const handleFecNac = (e) => {
    var esFecha = moment(e, "DD/MM/YYYY").isValid();
    if (esFecha) {
      var fec = new Date(e).toISOString();
      var fecha = moment(fec).format("DD/MM/YYYY");
      setFecNac(fecha);
    }
  };

  const handleOnChange = (email) => {
    // don't remember from where i copied this code, but this works.
    let re =
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

    if (re.test(email)) {
      return 1;
    } else {
      return 0;
    }
  };

  const iniciaConsulta = () => {
    if (idMedico === 0) {
      toast("El tipo de usuario no puede iniciar la consulta.", "warning");
      return;
    }
    saveDataInit();
  };

  const handleTipoDoc = (e) => {
    if (e === null) {
      setIdTipoDoc("");
      setDisabledUpload(true);
    } else {
      setIdTipoDoc(e);
      setDisabledUpload(false);
    }
  };

  const handleServicio = (e) => {
    if (e === null) {
      setIdServicio(0);
      setDisabledDiag(true);
      setDisabledIndic(true);
      setDisabledTrat(true);
    } else {
      setIdServicio(e);
      setDisabledDiag(false);
      setDisabledIndic(false);
      setDisabledTrat(false);
    }
  };

  const saveObservation = (props) => {
    console.log(
      "ID Anteced: ",
      props.idAnteced,
      " / NoItem: ",
      props.id,
      " Texto: ",
      props.obs
    );
  };

  const handleListaCitas = (e) => {
    if (e != null) {
      let _fec = e.replace("/", "-");
      _fec = _fec.replace("/", "-");
      console.log("Id Pac: ", idPaciente);
      getDatosCita(_fec, idPaciente);
    } else {
      setDiagnosticoCita("");
      setTratamientoCita("");
      setIndicacionesCita("");
      setObservaCita("");
      setImageList([]);
    }
  };

  const handleFileList = (e) => {
    setFileList(Array.from(e.target.files));
  };

  const saveConsulta = async () => {
    setLoading(true);
    const formData = new FormData();
    fileList.forEach((file) => {
      formData.append("file", file);
    });

    formData.append("id", idNegocio);
    formData.append("fecha", fecha);
    formData.append("hora", hora);
    formData.append("espacio", espacio.noEspacio);
    formData.append("idPaciente", idPaciente);
    formData.append("idMedico", idMedico);
    formData.append("idServicio", idServicio);
    formData.append("idTipoDoc", idTipoDoc);
    formData.append("idUser", idUser);
    formData.append("diagnostico", diagnostico);
    formData.append("tratamiento", tratamiento);
    formData.append("indicaciones", indicaciones);
    formData.append("observa", observa);

    await axios
      .post("Consultas/saveConsulta", formData, {
        headers: {
          Accept: "application/json",
          "Content-Type": "multipart/form-data",
        },
      })
      .then((res) => {
        if (res.data > 0) {
          toast("La consulta se ha finalizado", "success");
          setTimeout(() => {
            window.location.reload();
          }, [1200]);
        } else {
          setLoading(false);
          toast("Ocurrio un error al guardar la consulta", "error");
        }
      })
      .catch((error) => {
        setLoading(false);
        toast(
          "Ocurrio un error inesperado, valide su conexión a internet",
          "error"
        );
        console.log(error);
      });
  };

  const handleCellChange = async (props) => {
    var url = "Consultas/saveItem";
    const idNegocio = JSON.parse(localStorage.getItem("auth")).id;

    const data = {
      opc: props.opc,
      id: idNegocio,
      idPaciente: idPaciente,
      idAnteced: props.idAnteced,
      noItem: props.id,
      valorado: props.opc === "resp" ? props.valor : "",
      obs: props.opc === "resp" ? "" : props.texto,
    };

    await axios
      .post(url, data, {
        headers: {
          "Content-Type": "application/json",
        },
      })
      .then(async (res) => {
        toast("Se ha registrado la información.", "success");
      })
      .catch((error) => {
        toast("Ocurrio un error al guardar.", "error");
      });
  };

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768); // Update on resize
    };
    getPaciente();
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize); // Cleanup
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [imageList]);

  return (
    <div
      style={{
        marginLeft: "2%",
        marginRight: "2%",
        backgroundColor: "white",
        padding: "10px",
        borderRadius: "30px",
      }}
    >
      <Accordion activeKey={activeKey} bordered onSelect={setActiveKey}>
        {/* ACORDION DE LOS DATOS GENERALES */}
        <Accordion.Panel
          header={`Datos Generales`}
          defaultExpanded={defaultExpanded}
          bordered
          eventKey={1}
        >
          <Card bordered style={{ padding: "10px" }}>
            <div className="row">
              <div className="col-lg-4 col-md-4 col-sm-4">
                <b>Nombre completo</b>
                <Input value={nombre} onChange={(e) => setNombre(e)} />
              </div>
              <div className="col-lg-2 col-md-2 col-sm-2">
                <b>Fecha de nacimiento</b>
                <DateInput
                  format="dd/MM/yyyy"
                  id="fecNac"
                  name="fecNac"
                  value={fecNac}
                  onChange={(e) => setFecNac(e)}
                />
              </div>
              <div className="col-lg-2 col-md-2 col-sm-2">
                <b>Teléfono</b>
                <InputNumber
                  id="telefono"
                  maxLength={10}
                  min={0}
                  value={telefono}
                  readOnly
                />
              </div>
              <div className="col-lg-4 col-md-4 col-sm-4">
                <b>Correo</b>
                <Input
                  value={correo}
                  name="correo"
                  onChange={(e) => setCorreo(e)}
                />
              </div>
            </div>
            <br></br>
            <div className="row">
              <div className="col">
                <Panel bordered header="Domicilio">
                  <div className="row">
                    <div className="col-lg-3 col-md-3 col-sm-3">
                      <b>Calle y número</b>
                      <Input
                        value={domicilio}
                        onChange={(e) => setDomicilio(e)}
                      />
                    </div>
                    <div className="col-lg-3 col-md-3 col-sm-3">
                      <b>Colonia</b>
                      <Input value={colonia} onChange={(e) => setColonia(e)} />
                    </div>
                    <div className="col-lg-3 col-md-3 col-sm-3">
                      <b>Estado</b>
                      <Input value={estado} onChange={(e) => setEstado(e)} />
                    </div>
                    <div className="col-lg-3 col-md-3 col-sm-3">
                      <b>Municipio</b>
                      <Input
                        value={municipio}
                        onChange={(e) => setMunicipio(e)}
                      />
                    </div>
                  </div>
                </Panel>
              </div>
            </div>
            <br></br>
            <div className="row">
              <div className="col-lg-2 col-md-2 col-sm-2">
                <b>Estado Civil</b>
                <SelectPicker
                  searchable={false}
                  data={listEdoCivil}
                  value={edoCivil}
                  placeholder="Selecciona"
                  onChange={(e) => setEdoCivil(e)}
                  style={{ width: "auto" }}
                  block
                ></SelectPicker>
              </div>
              <div className="col-lg-2 col-md-2 col-sm-2">
                <b>Genero</b>
                <SelectPicker
                  block
                  searchable={false}
                  data={listGeneros}
                  value={genero}
                  placeholder="Selecciona"
                  onChange={(e) => setGenero(e)}
                ></SelectPicker>
              </div>
              <div className="col-lg-3 col-md-3 col-sm-3">
                <b>Ocupación</b>
                <Input value={ocupacion} onChange={(e) => setOcupacion(e)} />
              </div>
            </div>
          </Card>
          <br></br>
          <Button
            block
            appearance="primary"
            onClick={() => iniciaConsulta()}
            disabled={disabledIni}
            loading={loading}
          >
            Iniciar Consulta
          </Button>
        </Accordion.Panel>

        {/* header={`${itm.nombre}`}
                    bordered
                    disabled={disabledAccord2}
                    defaultExpanded={false}
                    eventKey={2} */}

        {/* ACORDION DE LOS ANTECEDENTES */}
        <Accordion.Panel
          header="Historia Clínica"
          bordered
          disabled={disabledAccord2}
          defaultExpanded={false}
          eventKey={2}
        >
          {listaAnteced.length > 0
            ? listaAnteced.map((itm, index) => {
                return (
                  <div key={`div-${index}`}>
                    <Accordion.Panel
                      header={`${itm.nombre}`}
                      bordered
                      disabled={disabledAccord2}
                      defaultExpanded={false}
                      eventKey={2}
                      key={`accord-${index}`}
                    >
                      <Table
                        striped
                        bordered
                        hover
                        responsive
                        key={`tbl-${index}`}
                        style={{
                          width: "100%",
                          cellPadding: "5",
                          cellSpacing: "10",
                          fontSize: isMobile ? "10px" : "16px",
                        }}
                        cellPadding={10}
                        cellSpacing={10}
                      >
                        <thead key={`headers-${index}`}>
                          <tr
                            key={`fila-${index}`}
                            style={{
                              borderBottom: "solid 2px",
                              paddingBottom: "15",
                            }}
                          >
                            {isMobile ? (
                              ""
                            ) : (
                              <th
                                key={`header0-${index}`}
                                style={{ textAlign: "center", width: "5%" }}
                              >
                                <b>#</b>
                              </th>
                            )}
                            <th
                              key={`header1-${index}`}
                              style={{ width: "30%" }}
                            >
                              <b>Item</b>
                            </th>
                            <th
                              key={`header2-${index}`}
                              style={{ width: "15%", textAlign: "center" }}
                            >
                              <b>Respuesta</b>
                            </th>
                            <th
                              key={`header3-${index}`}
                              style={{ width: "50%" }}
                            >
                              <b>Observaciones</b>
                            </th>
                          </tr>
                        </thead>
                        {itm.detalles.map((item, ix) => {
                          return (
                            <tr key={`fila-${ix}`}>
                              {isMobile ? (
                                ""
                              ) : (
                                <td
                                  key={`celda1-${ix}`}
                                  style={{ textAlign: "center" }}
                                >
                                  {item.id}
                                </td>
                              )}
                              <td key={`celda2${index}-${ix}`}>{item.Item}</td>
                              <td style={{ textAlign: "center" }}>
                                <select
                                  key={`select-${ix}`}
                                  style={{ border: 'none'}}
                                  onChange={(e) =>
                                    handleCellChange({
                                      opc: "resp",
                                      idAnteced: item.idAnteced,
                                      id: item.id,
                                      valor: e.target.value,
                                    })
                                  }
                                >
                                  <option
                                    key={`opt-select-SinVal-${ix}-${index}`}
                                    value=""
                                    selected={
                                      item.valorado === "" ? true : false
                                    }
                                  ></option>
                                  <option
                                    key={`opt-select-SI-${ix}-${index}`}
                                    value="SI"
                                    selected={
                                      item.valorado === "SI" ? true : false
                                    }
                                  >
                                    SI
                                  </option>
                                  <option
                                    key={`opt-select-NO-${ix}-${index}`}
                                    value="NO"
                                    selected={
                                      item.valorado === "NO" ? true : false
                                    }
                                  >
                                    NO
                                  </option>
                                </select>
                              </td>
                              <td key={`obs-${index}${ix}`}>
                                <Input
                                  defaultValue={item.observacion}
                                  style={{
                                    fontSize: isMobile ? "10px" : "16px",
                                  }}
                                  onBlur={(e) =>
                                    handleCellChange({
                                      opc: "obs",
                                      idAnteced: item.idAnteced,
                                      id: item.id,
                                      texto: e.target.value,
                                    })
                                  }
                                />
                              </td>
                            </tr>
                          );
                        })}
                      </Table>
                    </Accordion.Panel>
                  </div>
                );
              })
            : ""}
        </Accordion.Panel>

        {/* BLOQUE DE INICIO DE EXPEDIENTE */}
        <Accordion.Panel
          header={`Expediente`}
          bordered
          disabled={disabledAccord3}
          defaultExpanded={false}
          eventKey={4}
        >
          <Form>
            <Card shaded>
              <Card.Header as="h3">
                <div className="col-lg-9 col-md-9 col-sm-9">
                  <SelectPicker
                    searchable={true}
                    data={listCitas}
                    style={{ width: "90%" }}
                    block
                    placeholder="Registro de citas anteriores"
                    onChange={(e) => handleListaCitas(e)}
                  ></SelectPicker>
                </div>
              </Card.Header>
              <Card.Body>
                <div className="row">
                  <div className="col-lg-4 col-md-4 col-sm-4">
                    <Panel header="Diagnostico" bordered defaultExpanded>
                      <Input
                        as="textarea"
                        rows={4}
                        placeholder="Escriba el diagnostico"
                        readOnly
                        value={diagnosticoCita}
                      />
                    </Panel>
                  </div>
                  <div className="col-lg-4 col-md-4 col-sm-4">
                    <Panel
                      header="Tratamiento"
                      bordered
                      readOnly
                      defaultExpanded
                    >
                      <Input
                        as="textarea"
                        rows={4}
                        readOnly
                        value={tratamientoCita}
                      />
                    </Panel>
                  </div>
                  <div className="col-lg-4 col-md-4 col-sm-4">
                    <Panel header="Indicaciones" bordered defaultExpanded>
                      <Input
                        as="textarea"
                        rows={4}
                        readOnly
                        value={indicacionesCita}
                      />
                    </Panel>
                  </div>
                </div>
                <div className="row">
                  <div className="col">
                    <Panel header="Documentos" collapsible bordered>
                      <div className="row">
                        <div className="col-lg-4 col-md-4 col-sm-4">
                          {imageList.length > 0 ? (
                            <Carousel
                              autoplay
                              autoplayInterval={4000}
                              shape="bar"
                            >
                              {imageList.map((el, index) => {
                                if (el.tipoDoc === "File") {
                                  return (
                                    <div key={index}>
                                      <br></br>
                                      <ul>
                                        <a
                                          style={{ color: "white" }}
                                          href={`Images/Negocios/${idNegocio}/Expedientes/${idPaciente}/Consultas/${idConsulta}/${el.doc}`}
                                          target="_blank"
                                          rel="noreferrer"
                                        >
                                          {el.doc}
                                        </a>
                                      </ul>
                                    </div>
                                  );
                                } else {
                                  return (
                                    <div key={index}>
                                      <a
                                        href={`Images/Negocios/${idNegocio}/Expedientes/${idPaciente}/Consultas/${idConsulta}/${el.doc}`}
                                        target="_blank"
                                        rel="noreferrer"
                                      >
                                        <img
                                          height="400"
                                          alt="Doc o Imagen"
                                          src={`Images/Negocios/${idNegocio}/Expedientes/${idPaciente}/Consultas/${idConsulta}/${el.doc}`}
                                        ></img>
                                      </a>
                                    </div>
                                  );
                                }
                              })}
                            </Carousel>
                          ) : (
                            ""
                          )}
                        </div>
                        <div className="col-lg-8 col-lg-md-8 col-sm-8">
                          <b>Observaciones</b>
                          <Input
                            as="textarea"
                            rows={3}
                            placeholder="Observaciones..."
                            readOnly
                            value={observaCita}
                          />
                        </div>
                      </div>
                    </Panel>
                  </div>
                </div>
              </Card.Body>
            </Card>
          </Form>
        </Accordion.Panel>

        {/* BLOQUE DE INICIO DE LA CONSULTA */}
        <Accordion.Panel
          header={`Consulta`}
          bordered
          disabled={disabledAccord2}
          defaultExpanded={false}
          eventKey={3}
        >
          <Form>
            <Card shaded>
              <Card.Header as="h3">
                <div className="row">
                  <div className="col-lg-6 col-md-6 col-sm-6">
                    <SelectPicker
                      searchable={false}
                      data={listaMedicos}
                      style={{ width: "90%" }}
                      value={idMedico}
                      block
                      placeholder="Selecciona al usuario"
                      onChange={(e) => setIdMedico(e)}
                    ></SelectPicker>
                  </div>
                  <div className="col-lg-6 col-md-6 col-sm-6">
                    <SelectPicker
                      searchable={false}
                      data={listServicios}
                      style={{ width: "90%" }}
                      block
                      placeholder="Selecciona el servicio"
                      onChange={(e) => handleServicio(e)}
                    ></SelectPicker>
                  </div>
                </div>
              </Card.Header>
              <Card.Body>
                <div className="row">
                  <div className="col-lg-4 col-md-4 col-sm-4">
                    <Panel
                      header="Diagnostico"
                      collapsible
                      bordered
                      disabled={disabledDiag}
                    >
                      <Input
                        as="textarea"
                        rows={4}
                        placeholder="Escriba el diagnostico"
                        onChange={(e) => setDiagnostico(e)}
                      />
                    </Panel>
                  </div>
                  <div className="col-lg-4 col-md-4 col-sm-4">
                    <Panel
                      header="Tratamiento"
                      collapsible
                      bordered
                      disabled={disabledTrat}
                    >
                      <Input
                        as="textarea"
                        rows={4}
                        placeholder="Escriba el tratamiento"
                        onChange={(e) => setTratamiento(e)}
                      />
                    </Panel>
                  </div>
                  <div className="col-lg-4 col-md-4 col-sm-4">
                    <Panel
                      header="Indicaciones"
                      collapsible
                      bordered
                      disabled={disabledIndic}
                    >
                      <Input
                        as="textarea"
                        rows={4}
                        placeholder="Escriba las indicaciones"
                        onChange={(e) => setIndicaciones(e)}
                      />
                    </Panel>
                  </div>
                </div>
                <div className="row">
                  <div className="col">
                    <Panel
                      header="Documentos y Notas"
                      collapsible
                      bordered
                      disabled={disabledIndic}
                    >
                      <div className="row">
                        <div className="col-lg-5 col-md-5 col-sm-5">
                          <SelectPicker
                            searchable={false}
                            data={listaTipoDocs}
                            style={{ width: "90%" }}
                            block
                            placeholder="Selecciona el tipo de Documento"
                            onChange={(e) => handleTipoDoc(e)}
                          ></SelectPicker>
                        </div>
                        <div className="col-lg-7 col-md-7 cols-sm-7">
                          <input
                            type="file"
                            id="file"
                            onChange={(e) => handleFileList(e)}
                            disabled={disabledUPload}
                            multiple
                          />
                          {fileList.length > 0 && (
                            <div>
                              <p>Archivos seleccionados:</p>
                              <ul>
                                {fileList.map((file, index) => (
                                  <li key={index}>{file.name}</li>
                                ))}
                              </ul>
                            </div>
                          )}
                        </div>
                      </div>
                      <div className="row">
                        <div className="col">
                          <b>Notas</b>
                          <Input
                            as="textarea"
                            rows={3}
                            placeholder="Anotaciones..."
                            onChange={(e) => setObserva(e)}
                          />
                        </div>
                      </div>
                    </Panel>
                  </div>
                </div>
                <br></br>
                <div className="row">
                  <div className="col">
                    <Button
                      appearance="primary"
                      block
                      disabled={disabledDiag}
                      loading={loading}
                      onClick={() => saveConsulta()}
                    >
                      Guardar
                    </Button>
                  </div>
                </div>
              </Card.Body>
            </Card>
          </Form>
        </Accordion.Panel>
      </Accordion>
    </div>
  );
};

function toValueString(value, dataType) {
  return dataType === "date" ? value?.toLocaleDateString() : value;
}

const fieldMap = {
  string: Input,
  number: InputNumber,
  date: DatePicker,
  select: SelectPicker,
};

const EditableCell = ({
  key,
  rowData,
  dataType,
  dataKey,
  onChange,
  onEdit,
  ...props
}) => {
  const editing = rowData.status === "EDIT";

  const Field = fieldMap[dataType];
  const value = rowData[dataKey];
  const text = toValueString(value, dataType);
  const _key = key;

  return (
    <Cell
      {...props}
      className={editing ? "table-cell-editing" : ""}
      onDoubleClick={() => {
        onEdit?.(rowData.id);
      }}
    >
      {editing ? (
        <Field
          key={_key}
          defaultValue={value}
          searchable={false}
          data={[
            { label: "SI", value: "SI" },
            { label: "NO", value: "NO" },
          ]}
          onChange={(value) => {
            onChange?.(rowData.id, dataKey, value);
          }}
          style={{ height: "30px", width: "99%" }}
        />
      ) : (
        text
      )}
    </Cell>
  );
};

const saveObs = async (id, rowData, estatus) => {
  if (estatus === undefined) {
    return;
  }
  var url = "Consultas/saveItem";
  const idNegocio = JSON.parse(localStorage.getItem("auth")).id;
  const idPaciente = JSON.parse(
    localStorage.getItem("dataPaciente")
  ).idPaciente;

  const data = {
    id: idNegocio,
    idPaciente: idPaciente,
    idAnteced: rowData.idAnteced,
    noItem: rowData.id,
    valorado: rowData.valorado,
    obs: rowData.observacion,
  };

  await axios
    .post(url, data, {
      headers: {
        "Content-Type": "application/json",
      },
    })
    .then(async (res) => {
      console.log(res);
    })
    .catch((error) => {
      console.log(error);
    });
};

const ActionCell = ({
  key,
  rowData,
  dataKey,
  onEdit,
  onSave,
  onRemove,
  ...props
}) => {
  return (
    <Cell {...props} style={{ padding: "6px", display: "flex", gap: "4px" }}>
      <IconButton
        key={props.key}
        appearance="subtle"
        icon={rowData.status === "EDIT" ? <VscSave /> : <VscEdit />}
        onClick={() => {
          saveObs(rowData.id, rowData, rowData.status);
          onEdit(rowData.id);
        }}
      />
    </Cell>
  );
};
